import { render, staticRenderFns } from "./Exponen.vue?vue&type=template&id=4e1aad78&scoped=true"
import script from "./Exponen.vue?vue&type=script&lang=js"
export * from "./Exponen.vue?vue&type=script&lang=js"
import style0 from "./Exponen.vue?vue&type=style&index=0&id=4e1aad78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1aad78",
  null
  
)

export default component.exports